<template>
  <nuttrema-layout-default-slide :class="{ 'is-index-mode': index }">

    <template slot="collapsed-menu-top-brand">
      <nuttrema-brand-image link="professional-home"></nuttrema-brand-image>
    </template>

    <sidebar-menu-level-zero-collapsed
      slot="collapsed-menu-level-zero"
      class="collapsed-menu-level-zero is-collapsed is-small">
    </sidebar-menu-level-zero-collapsed>

    <sidebar-menu-level-zero-expanded slot="expanded-menu-level-zero" class="expanded-menu-level-zero is-expanded"></sidebar-menu-level-zero-expanded>

    <nuttrema-menu-list slot="sidebar-collapsed-bottom">
      <nuttrema-menu-list-item v-if="showPurchase">
        <router-link
           tag="a"
          :title="$t('label.purchase_new_subscription')"
          :to="{ name: 'instance-subscription-purchase-new' }">
          <nuttrema-iconica-sidebar-link theme="purchase" icon="fal fa-credit-card"></nuttrema-iconica-sidebar-link>
        </router-link>
      </nuttrema-menu-list-item>

      <nuttrema-menu-list-item>
          <sidebar-link-overlay-usermenu icon="fas fa-th" title="test" width="20%" minWidth="30em"></sidebar-link-overlay-usermenu>
      </nuttrema-menu-list-item>
    </nuttrema-menu-list>

  </nuttrema-layout-default-slide>
</template>

<script>
import { has, get } from 'lodash';

import { showInstancePurchaseOption } from 'utils/check-purchase';

import AbstractLayoutSet from 'components/ui/layout-set/abstract/abstract-layout-set';

import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

import SidebarMenuLevelZeroExpanded from 'components/ui/menu/level-zero/sidebar-menu-level-zero-expanded';
import SidebarMenuLevelZeroCollapsed from 'components/ui/menu/level-zero/sidebar-menu-level-zero-collapsed';

export default {
  mixins: [AbstractLayoutSet],
  name: 'layout-set-level-zero',
  components: {
    NuttremaIconicaSidebarLink,
    SidebarMenuLevelZeroExpanded,
    SidebarMenuLevelZeroCollapsed,
  },
  data() {
    return {
      active: null,
    };
  },
  computed: {
    PersonalProfile() {
      return this.$store.getters.PersonalProfile;
    },
    NoticesInstance() {
      return this.$store.getters.NoticesInstance;
    },
    showPurchase() {
      const scopes = get(this.PersonalProfile, 'meta.permissions.scopes', []);
      const instanceRestrictions = get(this.NoticesInstance, 'data.instance_restrictions');
      const subscriptionExpiry = has(this.NoticesInstance, 'data.subscription_expiry');

      return showInstancePurchaseOption(scopes, instanceRestrictions, subscriptionExpiry);
    },
  },
  methods: {
    toggleWestSlide(name) {
      console.log('toggleWestSlide', name);
      this.active = this.active === name ? null : name;
    },
  },
  created() {
    this.$store.dispatch('GetNoticesInstance');
    this.$store.dispatch('GetPersonalProfile');
  },
  beforeDestroy() {
    this.$store.dispatch('ClearNoticesInstance');
    this.$store.dispatch('ClearPersonalProfile');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/layout-set/general/layout-set-level-zero.vue